import { CssSize } from "../helpers/styles.helper";

export const defaultGridTemplateColumns = `1fr 2fr ${CssSize.s40}`;
export const mediaGridTemplateColumns = `190px 4fr repeat(3, 1fr) 1.5fr`;
